<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div *ngIf="isPageReady" class="flex flex-col h-full">

    <!-- This is not a local relabel. The change travels the whole way out. -->
    <div class="mx-3 mt-3 mb-2 p-3 qb-detail-card" style="border-color: var(--p-red-500, #ef4444)">
      <div class="text-sm font-semibold mb-1" style="color: var(--p-red-500, #ef4444)">
        <i class="pi pi-exclamation-triangle mr-1"></i>This change goes all the way through to Proximity
      </div>
      <div class="text-sm">
        Every product on every style listed below moves to the new color, and the change is sent to Proximity
        on the next push. Proximity price lists and program product lists that refer to this color are
        affected. Where a size exists in both colors, the system combines the two products into one and
        moves the job orders, purchase orders and item details to the product that stays. You cannot undo
        a combine.
      </div>
    </div>

    <div class="px-3 pb-2 flex items-end gap-3 flex-wrap">
      <uni-field label="Manufacturer">
        <input pInputText title="Manufacturer" [ngModel]="params.manufacturerName" disabled
               [style]="{ width: '180px' }" />
      </uni-field>

      <uni-field label="Change from this color">
        <p-dropdown [options]="candidateOptions" [(ngModel)]="fromFeatureChoiceId"
                    optionValue="FeatureChoiceId" optionLabel="label" [filter]="true" filterBy="label"
                    placeholder="Select a color..." [style]="{ 'min-width': '420px' }"
                    [disabled]="isApplying" />
      </uni-field>

      <uni-field label="To this color">
        <p-dropdown [options]="targets" [(ngModel)]="toFeatureChoiceId"
                    optionValue="id" optionLabel="label" [filter]="true" filterBy="label"
                    placeholder="Select a color..." [style]="{ 'min-width': '240px' }"
                    [disabled]="isApplying" />
      </uni-field>

      <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-search"
              [loading]="isScanning" [disabled]="!canScan" (click)="onScan()">
        <span>Find the Styles</span>
      </button>
    </div>

    <div *ngIf="scope" class="px-3 pb-2">
      <div class="qb-detail-card qb-primary-tint p-3">
        <table class="qb-info-table w-full">
          <tr>
            <td class="label">Sizes to change color</td>
            <td class="value font-semibold">{{ repointCount }}</td>
          </tr>
          <tr>
            <td class="label">Sizes to combine</td>
            <td class="value font-semibold" [style.color]="combineCount > 0 ? 'var(--p-red-500, #ef4444)' : null">
              {{ combineCount }}
              <span *ngIf="combineCount > 0" class="font-normal">&mdash; these products are merged and cannot be undone</span>
            </td>
          </tr>
          <tr>
            <td class="label">Styles affected</td>
            <td class="value">{{ actionableStyles.length }}</td>
          </tr>
          <tr>
            <td class="label">Left alone</td>
            <td class="value">
              {{ skippedProductCount }} product(s) on {{ skippedStyles.length }} style(s)
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div *ngIf="isApplying" class="px-3 pb-2 text-sm">
      The system changes the styles. {{ progressDone }} of {{ progressTotal }} done.
    </div>

    <div *ngIf="!isApplying && changedStyles > 0" class="px-3 pb-2 text-sm font-semibold">
      The system changed the color of {{ repointedProducts }} product(s)
      and combined {{ combinedProducts }} product(s) on {{ changedStyles }} style(s).
    </div>

    <div class="flex-1 min-h-0 px-3 pb-3">
      <app-ag-grid [gridOptions]="gridOptions" class="h-full"></app-ag-grid>
    </div>

    <div *ngIf="errorMessage" class="px-3 pb-2 text-sm" style="color: var(--p-red-500, #ef4444)">
      {{ errorMessage }}
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button pButton type="button" class="p-button-raised" [disabled]="!canApply" [loading]="isApplying"
            (click)="onApply()">
      <span>Change the Ready Styles</span>
    </button>
    <button pButton type="button" class="p-button-raised" [disabled]="isApplying" (click)="onCancel()">
      <span>Close</span>
    </button>
  </div>
</ng-template>
